(() => {
  function formatMoney(cents, moneyFormat, currency) {
    const numericCents = Number(cents) || 0;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(numericCents, moneyFormat);
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(numericCents / 100);
  }

  function getProgressParts(root, totalCents) {
    const thresholdCents = Number(root.dataset.freeShippingThreshold) || 0;
    const cartTotalCents = Number(root.dataset.freeShippingCartTotal) || 0;
    const projectedTotalCents = Math.max(Number(totalCents) || 0, 0);
    const remainingCents = Math.max(thresholdCents - projectedTotalCents, 0);
    const percent =
      thresholdCents > 0
        ? Math.min(Math.round((projectedTotalCents / thresholdCents) * 100), 100)
        : 0;

    return {
      thresholdCents,
      cartTotalCents,
      projectedTotalCents,
      remainingCents,
      percent,
      cartQualifies: thresholdCents > 0 && cartTotalCents >= thresholdCents,
      projectedQualifies: thresholdCents > 0 && projectedTotalCents >= thresholdCents
    };
  }

  function getMessage(root, parts) {
    const context = root.dataset.freeShippingContext;
    const moneyFormat = root.dataset.freeShippingMoneyFormat;
    const currency = root.dataset.freeShippingCurrency;

    const remainingMessage =
      root.dataset.freeShippingRemainingMessage ||
      "You're [amount] away from free shipping.";

    const qualifiedMessage =
      root.dataset.freeShippingQualifiedMessage ||
      'Add this to unlock free shipping.';

    const cartQualifiedMessage =
      root.dataset.freeShippingCartQualifiedMessage ||
      "You've unlocked free shipping!";

    if (context === 'cart') {
      if (parts.projectedQualifies) {
        return cartQualifiedMessage;
      }

      const amount = formatMoney(parts.remainingCents, moneyFormat, currency);
      return remainingMessage.replace('[amount]', amount);
    }

    if (context === 'product') {
      if (parts.cartQualifies) {
        return cartQualifiedMessage;
      }

      if (parts.projectedQualifies) {
        return qualifiedMessage;
      }

      const amount = formatMoney(parts.remainingCents, moneyFormat, currency);
      return remainingMessage.replace('[amount]', amount);
    }

    const amount = formatMoney(parts.remainingCents, moneyFormat, currency);
    return remainingMessage.replace('[amount]', amount);
  }

  function renderProgress(root, totalCents) {
    const parts = getProgressParts(root, totalCents);
    const message = root.querySelector('[data-free-shipping-message]');
    const bar = root.querySelector('[data-free-shipping-bar]');
    const progressbar = root.querySelector('[data-free-shipping-progressbar]');

    if (message) {
      message.textContent = getMessage(root, parts);
    }

    if (bar) {
      bar.style.width = `${parts.percent}%`;
    }

    if (progressbar) {
      progressbar.setAttribute('aria-valuenow', String(parts.percent));
    }
  }

  function updateCartProgress(root, cartTotalCents) {
    const total = Number(cartTotalCents) || 0;

    root.dataset.freeShippingCartTotal = String(total);
    root.hidden = false;

    renderProgress(root, total);
  }

  function updateProductProgress(root, options = {}) {
    const cartTotalCents = Number(root.dataset.freeShippingCartTotal) || 0;
    const variantPriceCents = Number(options.variantPriceCents ?? root.dataset.freeShippingVariantPrice) || 0;
    const quantity = Math.max(Number(options.quantity) || 1, 0);
    const variantAvailable = options.variantAvailable;

    if (variantAvailable === false) {
      root.hidden = true;
      return;
    }

    const projectedTotalCents = cartTotalCents + variantPriceCents * quantity;

    root.dataset.freeShippingVariantPrice = String(variantPriceCents);
    root.hidden = false;

    renderProgress(root, projectedTotalCents);
  }

  function initFreeShippingProgress(container = document) {
    container.querySelectorAll('[data-free-shipping-progress]').forEach((root) => {
      const context = root.dataset.freeShippingContext;

      if (context === 'cart') {
        updateCartProgress(root, root.dataset.freeShippingCartTotal);
      }

      if (context === 'product') {
        const buyButtons = root.closest('[data-buy-buttons], .book-buy-buttons');

        if (buyButtons && window.GLBBuyButtons && typeof window.GLBBuyButtons.update === 'function') {
          window.GLBBuyButtons.update(buyButtons);
        } else {
          updateProductProgress(root);
        }
      }
    });
  }

  function updateAllCartProgress(cartTotalCents) {
    const total = Number(cartTotalCents) || 0;

    document
      .querySelectorAll('[data-free-shipping-progress][data-free-shipping-context="cart"]')
      .forEach((root) => {
        updateCartProgress(root, total);
      });

    document
      .querySelectorAll('[data-free-shipping-progress][data-free-shipping-context="product"]')
      .forEach((root) => {
        root.dataset.freeShippingCartTotal = String(total);

        const buyButtons = root.closest('[data-buy-buttons], .book-buy-buttons');

        if (buyButtons && window.GLBBuyButtons && typeof window.GLBBuyButtons.update === 'function') {
          window.GLBBuyButtons.update(buyButtons);
        } else {
          updateProductProgress(root);
        }
      });
  }

  window.GLBFreeShippingProgress = {
    init: initFreeShippingProgress,
    updateCartProgress: updateAllCartProgress,
    updateProductProgress
  };

  document.addEventListener('DOMContentLoaded', () => {
    initFreeShippingProgress();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initFreeShippingProgress(event.target);
  });

  document.addEventListener('free-shipping:cart-update', (event) => {
    if (!event.detail || !event.detail.cart) return;

    updateAllCartProgress(event.detail.cart.total_price);
  });
})();